import moment from "moment";

const formateDate = (date) => {
  return moment(date).format("YYYY-MM-DD");
};
export default formateDate;
